export default __webpack_public_path__ + "static/c94e264d-7ead-4f6a-a5dc-9c78aad4e709-ebf1c636691f7d7859c9763ea0345e16.woff2";